export const auth = {
  login: {
    title: "Entrar",
    email: "Email",
    password: "Senha",
    submit: "Entrar",
    noAccount: "Não tem uma conta?",
    registerLink: "Registre-se aqui",
    success: "Login realizado com sucesso",
    error: "Falha no login",
    errorMessage: "Por favor, verifique suas credenciais",
    googleButton: "Continuar com Google",
    githubButton: "Continuar com GitHub",
    facebookButton: "Continuar com Facebook",
    twitterButton: "Continuar com Twitter",
  },
  register: {
    title: "Registrar",
    socialTitle: "Login Social",
    emailTitle: "Registrar com Email",
    email: "Email",
    password: "Senha",
    firstName: "Nome",
    lastName: "Sobrenome",
    submit: "Registrar",
    hasAccount: "Já tem uma conta?",
    loginLink: "Entre aqui",
    success: "Registro realizado com sucesso",
    error: "Falha no registro",
    errorMessage: "Por favor, tente novamente",
    referralCode: "Registrando com Código de Afiliado",
  },
  forgotPassword: "Esqueceu a Senha",
  forgotPasswordInstructions:
    "Digite seu e-mail e enviaremos um link para redefinir sua senha.",
  resetPassword: "Redefinir Senha",
  newPassword: "Nova Senha",
  confirmPassword: "Confirmar Senha",
  passwordMismatch: "As senhas não coincidem",
  passwordResetSuccess: "Senha redefinida com sucesso",
  passwordResetError: "Falha ao redefinir senha",
  resetEmailSent: "E-mail de redefinição enviado",
  resetEmailError: "Falha ao enviar e-mail de redefinição",
  sendResetEmail: "Enviar E-mail de Redefinição",
  backToLogin: "Voltar ao Login",
  emailVerification: "Verificação de Email",
  verificationSuccess: "Email verificado com sucesso",
  verificationError: "Falha na verificação",
  verificationTokenMissing: "Token de verificação ausente",
  verificationFailed: "Falha ao verificar email",
  resendVerification: "Reenviar email de verificação",
  verificationEmailSent: "Email de verificação enviado",
  verificationRequired: "Por favor, verifique seu email",
};
